import React from "react";
import Notes from '../components/Notes'
import AddNote from "./AddNote";
const Home = () => {
  return (
    <div>
      <div className="container my-4">
        <Notes/>
      </div>

    </div>
  );
};

export default Home;
